import React, { FC, useState } from 'react'

import DateString from '../Date/Date'
import ReviewText from '../ReviewText/ReviewText'
import UserInfo from '../UserInfo/UserInfo'

import css from './Review.module.scss'
import { IReview, ISlide } from '../../types'
import ReviewGallery from '../ReviewGallery/ReviewGallery'
import useWindowSize from '../../../hooks/useWindowSize'
import Reply from '../../common/Reply'

interface IReviewProps {
  review: IReview
  isProduct?: boolean
}

const Review: FC<IReviewProps> = ({ review, isProduct }) => {
  const [showReply, setShowReply] = useState(false)
  const { width } = useWindowSize()
  const isMobile = width <= 768
  const media: ISlide[] = [
    ...(review.videos
      ?.filter((v) => v.videoCover?.url && v?.url)
      ?.map((video) => ({
        src: `${process.env.NEXT_PUBLIC_BITRIX_ENDPOINT}${video.videoCover.url}`,
        id: video.id,
        type: 'video',
      })) || []),
    ...(review.images?.map((img) => ({
      src: img.url,
      id: img.id,
      type: 'img',
    })) || []),
  ] as ISlide[]

  return (
    <li className={css.review}>
      <UserInfo name={review.name} rate={review.rate} />
      <div className={css.textContainer}>
        <ReviewText
          text={review.text}
          setShowFull={setShowReply}
          product={isProduct ? null : review.product}
        />
        {media.length > 0 && (
          <ReviewGallery
            elements={media}
            id={review.id}
            maxCount={isMobile ? 3 : 4}
          />
        )}
        {showReply && review?.reply && <Reply text={review.reply} />}
      </div>
      <DateString dateString={review.date} />
    </li>
  )
}

export default Review
